import { HiCheckCircle } from 'react-icons/hi2';
import { useSelector } from 'react-redux';

import { selectDcsDegrees } from '@core/reducers/dcsSlice';
import { VoyagerInput } from '@core/reducers/inputsSlice';
import cn from '@core/utils/classNames';

import ImportantFactorsFlags from '../ImportantFactorsFlags';
import styles from './StepsTracker.module.css';

type StepsTrackerProps = {
  title?: string;
  stepsChecked?: 1 | 2 | 3;
  importantFactors?: VoyagerInput;
};

const StepsTracker = ({
  title = 'You’re just a few steps away from starting your degree:',
  stepsChecked = 1,
  importantFactors,
}: StepsTrackerProps) => {
  const [degree] = useSelector(selectDcsDegrees);

  return (
    <section className={styles.stepsTracker}>
      {title && <h3 className={styles.title}>{title}</h3>}
      <ol>
        <li>
          <h4 className={styles.stepTitle}>
            Take Our Quiz
            <span className={cn(styles.checkIcon, stepsChecked >= 1 && styles.checked)}>
              <HiCheckCircle size={22} />
            </span>
          </h4>
          <div className={styles.stepDescription}>
            You answered a few questions to help us tailor your program matches.
            {importantFactors && (
              <div className={styles.importantFactors}>
                <h5>Your Preferences</h5>
                {importantFactors && importantFactors.value && (
                  <ImportantFactorsFlags importantFactors={importantFactors} asColumn />
                )}
              </div>
            )}
          </div>
        </li>
        <li>
          <h4 className={styles.stepTitle}>
            Explore Your Matches{' '}
            <span className={cn(styles.checkIcon, stepsChecked >= 2 && styles.checked)}>
              <HiCheckCircle size={22} />
            </span>
          </h4>
          <div className={styles.stepDescription}>Explore schools that align with your goals and interests.</div>
        </li>
        <li>
          <h4 className={styles.stepTitle}>
            {`Select Your ${degree ?? ''} Degree`}
            <span className={cn(styles.checkIcon, stepsChecked === 3 && styles.checked)}>
              <HiCheckCircle size={22} />
            </span>
          </h4>
          <div className={styles.stepDescription}>
            Choose a program, connect with an advisor to discuss financial aid and next steps, and apply online.
          </div>
        </li>
      </ol>
    </section>
  );
};

export default StepsTracker;
